define('drops/boolImageInput/boolImageInput',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq',
    'lq/util',
    'lq/constants',
    'lq/required',
    'lq/tooltip'
], function ($, Drop, Style, lq, util, constants, Required, Tooltip) {
    'use strict';

    var defaults = {
        data: {
            size: { x: 50, y: 50 },
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            isTriStateEnabled: false,
            title: {
                option: Tooltip.hardcoded
            },
        }
    };

    function BoolImageInput(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);
        this.value = false;

        this.$img = $('<div />')
            .attr('tabindex', this.data.tabIndex)
            .addClass('bool-input-image')
            .addClass(this.data.value === true ? 'bool-input-true'
                : (this.data.value === false ? 'bool-input-false' : 'bool-input-null'))
            .appendTo(this.$element);

        this.changeValueTo(this.data.defaultValue || false);

        this.tooltip = new Tooltip(this, this.data.title, this.$img);

        if (!this.data.readOnly && !this.designData) {
            this.$img
				.css({ cursor: 'pointer' })
                .on('click', this.handleClickAndTriggerEvents.bind(this));
        }

        this.$element
            .addClass('boxToBorderSize')
            .css({
                whiteSpace: 'pre-wrap'
            });

        if (this.data.readOnly)
            this.$img.prop('readonly', true);
    }

    Drop.extend(BoolImageInput, Drop);

    BoolImageInput.typeName = 'BoolImageInput';

    BoolImageInput.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);
        this.renderStyles();
        this.applyPosition();
        this.tooltip.update();
    };

    BoolImageInput.prototype.postRender = function () {
        var self = this;
        var $labels = $("label[for='" + this.rootDrop.instanceId + '_' + this.data.id + "']");

        $labels.each(function () {
            $(this).on('click', self.handleClickAndTriggerEvents.bind(self));
        });
    };

    BoolImageInput.prototype.getValue = function () {
        return this.value;
    };

    BoolImageInput.prototype.handleClick = function () {
        if (!this.data.isTriStateEnabled)
            this.changeValueTo(!this.value);
        else {
            if (this.value) {
                this.changeValueTo(!this.value);
            } else if (this.value === false) {
                this.changeValueTo(null);
            } else {
                this.changeValueTo(true);
            }
        }
        this.updateRequiredIndicator();
    };

    BoolImageInput.prototype.clearValue = function () {
        this.changeValueTo(false);
        this.updateRequiredIndicator();
    };

    BoolImageInput.prototype.setValue = function (update) {
        var isTrue = this.isTrue(update);
        this.changeValueTo(isTrue);
        this.updateRequiredIndicator();
    };

    BoolImageInput.prototype.getNullImageUrl = function () {
        if (!this.data.nullImage)
            return lq.getCdnUrl('Drops/BoolImageInput/Defaults/null.png');
        return lq.getTenantUploads(this.data.nullImage);
    };

    BoolImageInput.prototype.getFalseImageUrl = function () {
        if (!this.data.falseImage)
            return lq.getCdnUrl(this.data.defaultFalseImage);
        return lq.getTenantUploads(this.data.falseImage);
    };

    BoolImageInput.prototype.getTrueImageUrl = function () {
        if (!this.data.trueImage)
            return lq.getCdnUrl(this.data.defaultTrueImage);
        return lq.getTenantUploads(this.data.trueImage);
    };

    BoolImageInput.prototype.changeValueTo = function (value) {
        var imageUrl;
        if (value === true) {
            imageUrl = this.getTrueImageUrl();
            this.$img.removeClass('bool-input-false bool-input-null').addClass('bool-input-true');
        } else if (value === false) {
            imageUrl = this.getFalseImageUrl();
            this.$img.removeClass('bool-input-true bool-input-null').addClass('bool-input-false');
        } else {
            imageUrl = this.getNullImageUrl();
            this.$img.removeClass('bool-input-true bool-input-false').addClass('bool-input-null');
        }

        if ((value === true && this.data.trueImage) || (value === false && this.data.falseImage) || ((value === undefined || value === null) && this.data.nullImage)){
            this.$img[0].style.removeProperty('background-image');
            this.$img[0].style.setProperty('background-image', `url(${imageUrl})`, 'important'); // jquery can't apply !important
        }
        else this.$img[0].style.removeProperty('background-image');

        this.value = value;
    };

    BoolImageInput.prototype.renderStyles = function () {
        Style.renderStyles(this);
    };

    BoolImageInput.prototype.isTrue = function (update) {
        if (!this.data.isTriStateEnabled) {
            return update.value === true ||
            (update.type === constants.valueTypes.string
                && update.value
                && update.value.toString().toLowerCase() === 'true');
        } else if (update.value === true ||
            (update.type === constants.valueTypes.string
                && update.value
                && update.value.toString().toLowerCase() === 'true')) {
            return true;
        } else if (update.value === false ||
            (update.type === constants.valueTypes.string
                && update.value
                && update.value.toString().toLowerCase() === 'false')) {
            return false;
        }
        return null;
    };

    BoolImageInput.prototype.handleClickAndTriggerEvents = function () {
        this.handleClick();

        var isChecked = this.value;
        this.triggerEventIfEnabled('toggled', isChecked);
        if (isChecked === true) {
            this.triggerEventIfEnabled('checked');
        } else if (isChecked === false) {
            this.triggerEventIfEnabled('unchecked');
        } else {
            this.triggerEventIfEnabled('nullchecked');
        }
    };

    BoolImageInput.prototype.hasValue = function () {
        var value = this.getValue();
        if (value === undefined || value === null || value === false)
            return false;
        return true;
    };

    return BoolImageInput;
});
